import { Backdrop, CircularProgress, Box, LinearProgress } from "@mui/material";

// `action` renders under the progress bar, for things the user can do while waiting -
// the bulk download puts its cancel button there.
export default function LoadProgress({ isFetching, text, action }) {
    return (
        <Backdrop
            sx={{
                backgroundColor: `rgba(54,54,54, 0.7)`,
                zIndex: 999999,
                display: 'flex',
                flexDirection: 'column',
            }}
            open={isFetching}
        >
            {text ? (
                <>
                    <Box sx={(theme) => ({
                        backgroundColor: theme.palette.primary.dark,
                        border: `1px solid ${theme.palette.primary.dark}`,
                        borderRadius: '8px',
                        padding: '5px 15px',
                        color: 'white',
                        marginTop: '10px'
                    })}>
                        {text}
                    </Box>
                    <LinearProgress sx={{ width: '260px', marginTop: '20px' }} />
                    {action ? <Box sx={{ marginTop: '16px' }}>{action}</Box> : null}
                </>
            ) : (
                <CircularProgress color='primary' />
            )}
        </Backdrop>
    );
}
